<template>
  <div class="weather-background">
    <canvas id="weather-canvas"></canvas>
    <div class="background-overlay"></div>
  </div>
</template>

<script>
import { useWeatherAnimation } from "../../../js/useWeatherAnimation";

export default {
  name: "WeatherBackground",
  data() {
    return {
      disposeWeatherAnimation: null,
    };
  },
  mounted() {
    const { initializeWeatherAnimation } = useWeatherAnimation();
    this.disposeWeatherAnimation = initializeWeatherAnimation();
  },
  beforeUnmount() {
    if (typeof this.disposeWeatherAnimation === "function") {
      this.disposeWeatherAnimation();
      this.disposeWeatherAnimation = null;
    }
  },
};
</script>

<style scoped>
.weather-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background: linear-gradient(135deg, #233845 0%, #1a2a35 50%, #1a2a35 100%);
}

#weather-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  z-index: 1;
}

.background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(35, 56, 69, 0.6) 0%,
    rgba(26, 42, 53, 0.6) 50%,
    rgba(26, 42, 53, 0.6) 100%
  );
  z-index: 2;
  pointer-events: none;
}
</style>
